import { Account } from 'model/IChat';
import { useMemo } from 'react';
import FeatureFlags from '~/featureFlags';

const useHasTimelyResponseFeatureFlag = (account?: Account) =>
  useMemo(
    () =>
      account &&
      FeatureFlags.isFeatureFlagSetForAccount(account, 'timelyResponse'),
    [account],
  );

export default useHasTimelyResponseFeatureFlag;
